<template>
  <div>
    <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
      <el-form-item label="商户号：">
        <el-input v-model.trim="searchForm.mchId" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="searchForm.state" clearable>
          <el-option label="套餐余额在用" value="5"></el-option>
          <el-option label="赠送金在用" value="1"></el-option>
          <el-option label="待用" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btnArea">
        <el-button type="primary" @click="getPkgGroupListPageHandle">查询</el-button>
        <el-button type="success" icon="el-icon-s-ticket" @click="oldSelect">老用户收款配置</el-button>
        <el-button type="success" icon="el-icon-s-ticket" @click="priceSelect">赠送金收款配置</el-button>
        <!-- <el-button type="primary" @click="showAddPkgGroup">新增</el-button>
                 <el-button type="primary" @click="updateZero">重置轮询规则</el-button> -->

      </el-form-item>
    </el-form>
    <el-table :data="tbpg.tableData" border highlight-current-row style="width: 100%;"
      :header-cell-style="{ background: '#f5f5f5' }">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="name" label="商户号" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="remark" label="商户备注" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="sumPrice" label="已收款金额/元" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="limitPrice" label="限制收款金额/元" align="center" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="unHandle" label="未处理投诉" align="center" show-overflow-tooltip></el-table-column> 
            <el-table-column prop="handing" label="处理中投诉" align="center" show-overflow-tooltip></el-table-column> 
            <el-table-column prop="handOut" label="超时投诉" align="center" show-overflow-tooltip></el-table-column> 
            <el-table-column prop="handNext" label="用户新留言" align="center" show-overflow-tooltip></el-table-column>  -->
      <el-table-column prop="stateName" label="状态" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="subRemark" label="系统备注" align="center" show-overflow-tooltip></el-table-column>


      <el-table-column label="操作" align="center" width="250">
        <template slot-scope="scope">
          <!-- <el-button type="text"  size="small" v-if="scope.row.state==3" style="color: green"  @click="updateSimState(scope.row.id)" >
                    启用
                  </el-button> -->
          <el-button type="text" size="small" @click="showEditPkgGroup(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="tbpg.currentPage"
      :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
      layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
    </el-pagination>
    <el-dialog :append-to-body="true" :title="title" :visible.sync="addGroupVisibale" width="600px" @close="cancel"
      :close-on-click-modal="false">
      <el-form ref="addOrEditGroupForm" :model="addOrEditGroupForm" :rules="addOrEditGroupRules" label-width="120px">

        <el-form-item label="商户备注：" prop="remark">
          <el-input v-model.trim="addOrEditGroupForm.remark" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="限制收款金额：" prop="limitPrice">
          <el-input v-model.trim="addOrEditGroupForm.limitPrice" placeholder="" clearable></el-input>
        </el-form-item>


        <!-- <el-form-item label="回调密钥：" prop="mchPwdKey">
                    <el-input v-model.trim="addOrEditGroupForm.mchPwdKey" clearable></el-input>
                </el-form-item>     -->
        <!--                 
                <el-form-item label="商户类型：" prop="">
                    <el-radio-group v-model="addOrEditGroupForm.subType">
                        <el-radio :label="20">微信商户</el-radio>
                        <el-radio :label="50">乐刷商户</el-radio>
                        <el-radio :label="60">汇付商户</el-radio>
                    </el-radio-group>
                </el-form-item>  
                 -->
        <el-form-item label="商户状态：" prop="">
          <el-radio-group v-model="addOrEditGroupForm.state">
            <el-radio :label="3">待用</el-radio>
            <el-radio :label="5">套餐余额在用</el-radio>
            <el-radio :label="1">赠送金在用</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="success" plain icon="el-icon-plus" @click="addOrEidtGroupHandle">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" title="余额参数示列" :visible.sync="shareImgs" width="700px" @close="cancel1"
      :close-on-click-modal="false">
      <div style="text-align: center; padding: 10px 0; color: #F56C6C;">注：最多只支持6个参数，amount代表充值金额/元
        giftBalance表示赠送金额/元。请修改后完整输入此参数</div>
      <div style="text-align: center; width:100%;">
        <p alt="" style="margin: 0 auto;">{{ urls }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="copy()" class="copy_url" :data-clipboard-text="urls">复制参数</el-button>
      </div>
    </el-dialog>


    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="shareGroup" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="shareForm" :model="shareForm" label-width="120px">
        <el-form-item label="商品展示图(建议像素512*512)：">
          <input type="file" ref="file1" placeholder="必选" />
          <img :src="getImgUrl() + shareForm.shareImg" alt="" width="150" height="150" />
        </el-form-item>

        <el-form-item label="商品标题:" prop="shareName">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareName" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品分类:" prop="shareType">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareType" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="商品价格/元:" prop="sharePrice">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.sharePrice" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="分代理商佣金/元:" prop="shareYongjing">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareYongjing" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="上下架状态：" prop="isShare">
          <el-radio-group v-model="shareForm.isShare">
            <el-radio :label="0">下架</el-radio>
            <el-radio :label="1">上架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分类排序:" prop="shareTypeOrderBy">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareTypeOrderBy" placeholder="选填（数字越大排序越靠前）" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品排序:" prop="shareShopOrderBY">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareShopOrderBY" placeholder="选填（数字越大排序越靠前）" clearable></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="autoFlg" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="updateAuto" :model="updateAuto" label-width="120px">
        <p style="color:red">仅仅支持自运营流量池的卡。卡当前套餐使用完后 可用余额自动购买绑定的套餐</p>

        <el-form-item label="续费套餐编码:" prop="autoState">
          <el-col :span="22">
            <el-input v-model.trim="updateAuto.autoPkgId" placeholder="流量超套后 将会自动用余额续费此套餐" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="续费状态：" prop="autoState">
          <el-radio-group v-model="updateAuto.autoState">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="updateAutoSure()">确 定</el-button>
      </div>
    </el-dialog>



    <el-dialog :append-to-body="true" class="formDialog" title="赠送金支付类型" :visible.sync="priceFlg" width="600px"
      @close="priceFlg=false" :close-on-click-modal="false">
      <el-form ref="priceData" :model="priceData" label-width="120px">
        <el-form-item label="支付类型：" prop="">
          <el-radio-group v-model="priceData.payType">
            <el-radio :label="0">跟随主配置</el-radio>
            <el-radio :label="92">易支付</el-radio>
            <el-radio :label="94">火脸支付</el-radio>
            <el-radio :label="20">微信支付</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="priceFlg=false">取 消</el-button>
            <el-button type="primary" @click="priceSure()">确 定</el-button>
          </div>
    </el-dialog>

    <el-dialog :append-to-body="true" class="formDialog" title="老用户支付类型" :visible.sync="oldFlg" width="600px"
      @close="priceFlg=false" :close-on-click-modal="false">
      <el-form ref="oldData" :model="oldData" label-width="120px">
        <el-form-item label="支付类型：" prop="">
          <el-radio-group v-model="oldData.payType">
            <el-radio :label="0">跟随主配置</el-radio>
            <el-radio :label="5">易支付</el-radio>
            <el-radio :label="3">火脸支付</el-radio>
            <el-radio :label="1">微信支付</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="oldFlg=false">取 消</el-button>
            <el-button type="primary" @click="oldSure()">确 定</el-button>
          </div>
    </el-dialog>





  </div>
</template>
<script>
import { getPkgGroupListPage, addPkgGroup, updatePkgGroup, changePkgGroupState, getPkgIsMonthOption } from '@/api/package.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
export default {
  data() {
    return {
      autoName: '轮询已关闭',

      autoFlg: false,
      updateAuto: {
        id: '',
        state: '',
        autoPkgId: ''
      },
      existBackImg: false,
      shareGroup: false,
      existBackImg1: false,
      shareGroup1: false,
      shareGroup11: false,
      shareForm: {
        id: "",
        name: "",
        subId: "",
        subKey: "",
        shareName: "",
        shareImg: "",
        priceImgUrl: "",
        isShare: "",

        shareType: '',
        shareYongjing: '',
        sharePrice: '',
        shareTypeOrderBy: '',
        shareShopOrderBY: '',

      },
      isMiaoList: [

        {
          code: 0,
          description: '不秒反'
        },
        {
          code: 1,
          description: '一次性秒反'
        },
        {
          code: 2,
          description: '一次性秒反+套餐秒反'
        }
      ],
      urls: '',
      shareImgs: false,
      searchForm: {
        id: "",
        mchId: '',
        mchPwd: '',
        mchPwdKey: '',
        subType: '20',
        subState: '',
        remark: ''
      },
      tbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      addOrEditGroupForm: {
        id: "",
        mchId: '',
        mchPwd: '',
        state: '',
        mchPwdKey: '',
        subType: '20',
        subState: '',
        limitPrice: '',
        remark: '',
        cookie: ''
      },
      branchSupplierOption: [],
      branchSupplierOptions: [],
      isPriceOption: [
        {
          code: 0,
          description: '不限制'
        },
        {
          code: 1,
          description: '限制余额'
        },
        {
          code: 2,
          description: '限制余额并且开户预存'
        }
      ],
      isVoiceOption: [
        {
          code: 0,
          description: '流量'
        },
        {
          code: 1,
          description: '流量+语音'
        }
      ],
      currentId: '',
      addFlag: null,
      addGroupVisibale: false,
      title: '',
      pkgTypeOption: [],
      supplierOption: [],
      isMonthOption: [],
      addOrEditGroupRules: {
        name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择套餐名称', trigger: 'change' }],
        isNextMonth: [{ required: true, message: '请选择套餐名称', trigger: 'change' }],
        supplierType: [{ required: true, message: '请选择套餐名称', trigger: 'change' }]
      },

      oldFlg: false,
      priceFlg: false,

      oldData: {
        payType: '',
      },
      priceData: {
        payType: '',
      }



    }
  },
  methods: {
    oldSelect() {
      common.sysRequest("pkg/group/select/old/pay", {}, "post").then((res) => {
        if (res.data.code == 200) {
          this.oldData.payType = res.data.data;
          this.oldFlg = true;
        } else {
          this.$message.error(res.data.message);;
        }
      })
        .catch((err) => console.error(err));
    },
    priceSelect() {
      common.sysRequest("pkg/group/select/new/price", {}, "post").then((res) => {
        if (res.data.code == 200) {
          this.priceData.payType = res.data.data;
          this.priceFlg = true;
        } else {
          this.$message.error(res.data.message);;
        }
      })
        .catch((err) => console.error(err));
    },

    priceSure() {
      common.sysRequest("pkg/group/update/new/price", this.priceData, "post").then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message);;
          this.priceFlg = false;
        } else {
          this.$message.error(res.data.message);;
        }
      })
        .catch((err) => console.error(err));
    },

    oldSure() {
      common.sysRequest("pkg/group/update/old/pay", this.oldData, "post").then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message);;
          this.oldFlg = false;
        } else {
          this.$message.error(res.data.message);;
        }
      })
        .catch((err) => console.error(err));
    },





    updateZero() {
      common.sysRequest("pkg/group/set/zero", {}, "post").then((res) => {
        if (res.data.code == 200) {
          this.getPkgGroupListPageHandle();
        } else {
          this.$message.error(res.data.message);;
        }
      })
        .catch((err) => console.error(err));
    },
    getAutoName() {
      common.sysRequest("pkg/group/select/auto/State", {}, "post").then((res) => {
        if (res.data.data == 0) {
          this.autoName = '轮询已关闭';
        } else {
          this.autoName = '轮询已开启';
        }
      })
        .catch((err) => console.error(err));

    },
    updateAutoMy() {

      common.sysRequest("pkg/group/update/auto/State", { state: this.autoName == '轮询已关闭' ? 2 : 0 }, "post").then((res) => {
        if (res.data.code == 200) {
          this.getAutoName();
        } else {
          this.$message.error(res.data.message);;
        }
      })
        .catch((err) => console.error(err));

    },

    updateSimState(id) {
      var data = {
        id: id
      }
      common.sysRequest("pkg/group/update/pay", data, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

    },

    showbtnText(state) {
      return common.showTxtByState(state, { 0: "禁用", 1: "启用" });
    },
    updateAutoSure() {
      common.sysRequest("pkg/group/update/auto/pkg", this.updateAuto, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.autoFlg = false;
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },
    updateAutoState(row) {
      this.updateAuto.id = row.id;
      this.updateAuto.autoPkgId = row.autoPkgId;
      this.updateAuto.autoState = row.autoState;
      this.autoFlg = true;
    },
    addOrEidtPkgHandle() {
      let fd = new FormData();
      Object.keys(this.shareForm).forEach((key) => {
        fd.append(key, this.shareForm[key]);
      });
      fd.append("title", this.$refs.file1.files[0]);

      common
        .sysRequest("pkg/group/insert/share", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$refs.file1.value = "";
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.shareGroup = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },
    cancel12() {
      this.autoFlg = false;
      this.shareGroup = false;
      this.existBackImg1 = false;
      this.shareGroup1 = false;
      this.shareGroup11 = false;
      this.$refs.shareForm.resetFields();
    },
    sharePkgGroup(row) {

      this.shareForm.shareType = row.shareType;
      this.shareForm.sharePrice = row.sharePrice;
      this.shareForm.shareYongjing = row.shareYongjing;
      this.shareForm.shareTypeOrderBy = row.shareTypeOrderBy;
      this.shareForm.shareShopOrderBY = row.shareShopOrderBY;

      this.shareForm.id = row.id;
      this.shareForm.shareName = row.shareName;
      this.shareForm.shareImg = row.shareImg;
      this.shareForm.isShare = row.isShare;
      this.existBackImg = true;
      this.shareGroup = true;
    },
    //复制功能
    copy() {
      var clipboard = new Clipboard('.copy_url')
      clipboard.on('success', e => {
        this.$message.success('复制成功');
        this.shareImgs = false;
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message.success('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    },
    showYue() {
      this.urls = '[{"amount":25,"giftBalance":0},{"amount":35,"giftBalance":0.5},{"amount":50,"giftBalance":1},{"amount":100,"giftBalance":2},{"amount":200,"giftBalance":5},{"amount":500,"giftBalance":20}]'
      this.shareImgs = true;
    },
    cancel() {
      this.shareImgs = false;
      this.addGroupVisibale = false;
      this.$refs.addOrEditGroupForm.resetFields();
    },
    cancel1() {
      this.shareImgs = false;
    },
    showbtnText(state) {
      return common.showTxtByState(state, { 0: '启用', 1: '禁用' })
    },
    getPkgGroupListPageHandle($event) {
      common.resetCurrentPage(this, $event, 'tbpg');
      var data = common.getRequestParams(this, 'tbpg', this.searchForm);

      common.sysRequest('pkg/group/listPage/pay', data, 'post').then(res => {
        common.listCallback(this, res, 'tbpg');
      })
    },
    showAddPkgGroup() {
      this.addGroupVisibale = true;
      this.addFlag = true;
      this.title = "新增";
      for (let val in this.addOrEditGroupForm) {
        this.addOrEditGroupForm[val] = "";
      }
    },
    showEditPkgGroup(row) {
      this.addGroupVisibale = true;
      this.addFlag = false;
      this.title = "修改";

      this.addOrEditGroupForm.id = row.id;
      this.addOrEditGroupForm.limitPrice = row.limitPrice;
      this.addOrEditGroupForm.cookie = row.cookie;
      this.addOrEditGroupForm.mchId = row.mchId;
      this.addOrEditGroupForm.mchPwd = row.mchPwd;
      this.addOrEditGroupForm.mchPwdKey = row.mchPwdKey;
      this.addOrEditGroupForm.subType = row.subType;
      this.addOrEditGroupForm.state = row.state;
      this.addOrEditGroupForm.remark = row.remark;
    },
    addOrEidtGroupHandle() {
      var _this = this;
      this.$refs.addOrEditGroupForm.validate(valid => {
        if (valid) {
          var data = this.addOrEditGroupForm;
          if (this.addFlag == true) {
            common.sysRequest('pkg/group/add/pay', data, 'post').then(res => {
              if (res.data.code == 200) {
                _this.getPkgGroupListPageHandle();
                _this.addGroupVisibale = false;
                _this.$message.success(res.data.message)
              } else {
                _this.$message.error(res.data.message)
              }
            })
            addPkgGroup(data).then(res => callback(res))
          } else {
            common.sysRequest('pkg/group/update/pay', data, 'post').then(res => {
              if (res.data.code == 200) {
                _this.getPkgGroupListPageHandle();
                _this.addGroupVisibale = false;
                _this.$message.success(res.data.message)
              } else {
                _this.$message.error(res.data.message)
              }
            })
          }
        }
      })
    },
    changeStateHandle(id) {
      var _this = this;
      var data = {
        id
      }
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        common.sysRequest('pkg/group/delete/pay', data, 'post').then(res => {
          if (res.data.code == 200) {
            _this.getPkgGroupListPageHandle();
            _this.$message.success(res.data.message)
          } else {
            _this.$message.error(res.data.message)
          }
        })
      }).catch(() => {

      });



    },
    handleSizeChange(val) {
      this.tbpg.pageSize = val;
      this.getPkgGroupListPageHandle();
    },
    handleCurrentChange(val) {
      this.tbpg.currentPage = val
      this.getPkgGroupListPageHandle();
    }
  },
  created() {
    this.getAutoName();
    this.getPkgGroupListPageHandle();
    common.getPkgTypeOptionCom(this, 'pkgTypeOption');
    common.getSupplierOptionCom(this, 'supplierOption');
    common.getSupplierLimitOptionCom(this, 'branchSupplierOption')
    common.getSupplierLimitOptionComs(this, 'branchSupplierOptions')
    getPkgIsMonthOption().then(res => {
      if (res.data.code == 200) {
        this.isMonthOption = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    })
  }
}
</script>
<style></style>
